module.exports = __webpack_public_path__ + "static/blurred_background-0d55d9d84da1ffc9da2cf60a4f326428.jpg";